import React from 'react';
import { Menu, MenuItem, ListItemIcon } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import UpdateIcon from '@mui/icons-material/Update';
interface ViewContextMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onApply: () => void;
  onRename: () => void;
  onUpdate: () => void;
  onDelete: () => void;
}

const ViewContextMenu: React.FC<ViewContextMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onApply,
  onRename,
  onUpdate,
  onDelete,
}) => {
  return (
    <Menu
      data-testid="view-context-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
    >
      <MenuItem
        data-testid="menu-item-apply"
        onClick={() => {
          onApply();
          onClose();
        }}
      >
        <ListItemIcon>
          <CheckCircleOutlineIcon fontSize="small" />
        </ListItemIcon>
        Apply
      </MenuItem>
      <MenuItem
        data-testid="menu-item-rename"
        onClick={() => {
          onRename();
          onClose();
        }}
      >
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        Rename
      </MenuItem>
      <MenuItem
        data-testid="menu-item-update"
        onClick={() => {
          onUpdate();
          onClose();
        }}
      >
        <ListItemIcon>
          <UpdateIcon fontSize="small" />
        </ListItemIcon>
        Update with Current State
      </MenuItem>
      <MenuItem
        data-testid="menu-item-delete"
        onClick={() => {
          onDelete();
          onClose();
        }}
      >
        <ListItemIcon>
          <DeleteIcon fontSize="small" />
        </ListItemIcon>
        Delete
      </MenuItem>
    </Menu>
  );
};

export default ViewContextMenu;
